export const themes = {
  'default-light': {
    primaryColor: '#30D096',
    primaryTextColor: '#30D096',
    primaryColorTransparency30: '#30D0964C',
    primaryButtonColor: '#17C28580',
  },
  'default-dark': {
    primaryColor:'#000',
    primaryTextColor: '#000',
  },
  'YWY-light': {
    primaryColor: '#02DCB3',
    primaryTextColor: '#02DCB3',
    primaryColorTransparency30: '#02DCB34C',
    primaryButtonColor: '#02dcb37f',
  },
  'YWY-dark': {
    primaryColor:'#111',
    primaryTextColor: '#111',
  },
};